module.exports = __webpack_public_path__ + "static/img/60.0a59408.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/digital/news/60.png
// module id = cI7N
// module chunks = 0